import React from 'react';
import {
  TextField, Button, Grid, Typography, Link
} from '@material-ui/core';
import SomaStatus from '../../components/SomaStandard/SomaStatus';
import MicrosoftIcon from '../../assets/images/icons/microsoftIcon.svg';


const LoginForm = (props) => {
  const { login, senha, banco } = props.credentials;

  return (
    <form style={{ width: "350px", textAlign: "center" }} onSubmit={(e) => {
      e.preventDefault();
      props.onConfirm(login, senha, banco);
    }}>
      <Grid container direction='column' justify='center' spacing={3} >
        <Grid item >
          <Typography variant="h6" style={{ textAlign: "left", color: "black", fontSize: '16px', fontFamily: 'flama-basic' }}>
            CLIFOR
          </Typography>
          <TextField onChange={(event) => props.onChange('login', event.target.value)} value={login} size="small" InputProps={{ style: { background: '#E9E9E9', borderRadius: 0, border: 0, width: '95%' } }} inputProps={{ style: { padding: '12px' } }} variant="filled" fullWidth />
        </Grid>
        <Grid item>
          <Typography variant="h6" style={{ textAlign: "left", color: "black", fontSize: '16px', fontFamily: 'flama-basic' }}>
            SENHA
          </Typography>
          <TextField onChange={(event) => props.onChange('senha', event.target.value)} value={senha} InputProps={{ style: { background: '#E9E9E9', borderRadius: 0, border: '0px', height: '40px', width: '95%' } }} inputProps={{ style: { padding: '12px' } }} variant="filled" type="password"
            fullWidth />
        </Grid>
        <Grid container justify='center' spacing={3} style={{ width: "100%" }}>
          <Grid item style={{ marginBottom: "5px" }}>
            <Typography variant="h6" style={{ color: "#6C6C6C", fontSize: '0.9rem', fontFamily: 'flama-book' }}>Não sabe sua senha? <Link style={{ color: '#454545', fontFamily: 'flama-medium', textDecoration: "underline", cursor: "pointer" }} onClick={props.onForgotPassword}>Clique aqui.</Link> </Typography>
          </Grid>

          <Grid item style={{ width: "100%", display: "flex", alignItems: "center", flexFlow: "column" }}>
            <Button type="submit" disabled={props.status === 'pending'} variant="contained" style={{
              width: "95%",
              height: 42, border: '4px solid black', backgroundColor: "black",
              color: 'white', fontFamily: 'flama-basic', fontSize: "1rem", fontWeight: 'bold', borderSizing: "border-box"
            }}>
              <SomaStatus status={props.status === 'pending' ? 'waitComponent' : 'result'} >
                Entrar
              </SomaStatus>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};
export default LoginForm;
